// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ant-select, .ant-select-outlined {
  height: 40px !important;
  width: 250px !important;
}
.ant-select.ant-select-outlined.single-select {
  height: 35px !important;
  width: 100% !important;
}

.ant-picker, .ant-picker-range {
  height: 40px !important;
  width: 250px !important;
}
.custom-range-date .ant-picker {
  height: 40px !important;
  width: 100% !important;
}

.custom-range-date  {
  width: 100% !important;
}
.ant-drawer-body {
  padding: 0 !important;
  overflow: auto !important;
}

/* Active menu item styles */
li.active-menu-item, 
li.active-menu-item a,
a.active-menu-item,
div.active-menu-item {
  background-color: #E6F7FA;
  background-color: var(--color-primary-light, #E6F7FA);
  color: #F17A20;
  color: var(--color-primary, #F17A20);
  font-weight: 700;
  position: relative;
  border-radius: 8px;
}
.ant-select.single-select-filter {
  width: 100% !important;
  min-width: 0 !important;
  min-width: initial !important;
}

/* Submenu active item styles */
/* ul.ml-8 li.active-menu-item,
ul.ml-8 li.active-menu-item a {
  background-color: transparent;
  color: var(--color-primary, #F17A20);
  font-weight: 700;
} */

/* Remove the left accent bar for all active items */
/* ul.ml-8 li.active-menu-item::before,
li.active-menu-item::before,
div.active-menu-item::before {
  display: none;
} */

/* Hover styles */
li.active-menu-item:hover, 
li.active-menu-item a:hover,
a.active-menu-item:hover,
div.active-menu-item:hover {
  border-radius: 8px;
}

/* Hover eases in. The selected row changes immediately, with no fade fighting the click. */
a.student-menu-link {
  color: #828282;
}
a.student-menu-link:hover {
  background-color: rgba(241,122,32,0.10196);
  color: #F17A20;
  transition: background-color 120ms ease-out, color 120ms ease-out;
}
a.student-menu-link.active-menu-item,
a.student-menu-link.active-menu-item:hover {
  background-color: rgba(241,122,32,0.10196);
  color: #F17A20;
}

`, "",{"version":3,"sources":["webpack://./src/components/LayoutStudent/layout.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;;;;EAIE,yBAAqD;EAArD,qDAAqD;EACrD,cAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,uBAA2B;EAA3B,6BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;;;;;GAKG;;AAEH,oDAAoD;AACpD;;;;GAIG;;AAEH,iBAAiB;AACjB;;;;EAIE,kBAAkB;AACpB;;AAEA,2FAA2F;AAC3F;EACE,cAAc;AAChB;AACA;EACE,0CAA2B;EAC3B,cAAc;EACd,iEAAiE;AACnE;AACA;;EAEE,0CAA2B;EAC3B,cAAc;AAChB","sourcesContent":["\n.ant-select, .ant-select-outlined {\n  height: 40px !important;\n  width: 250px !important;\n}\n.ant-select.ant-select-outlined.single-select {\n  height: 35px !important;\n  width: 100% !important;\n}\n\n.ant-picker, .ant-picker-range {\n  height: 40px !important;\n  width: 250px !important;\n}\n.custom-range-date .ant-picker {\n  height: 40px !important;\n  width: 100% !important;\n}\n\n.custom-range-date  {\n  width: 100% !important;\n}\n.ant-drawer-body {\n  padding: 0 !important;\n  overflow: auto !important;\n}\n\n/* Active menu item styles */\nli.active-menu-item, \nli.active-menu-item a,\na.active-menu-item,\ndiv.active-menu-item {\n  background-color: var(--color-primary-light, #E6F7FA);\n  color: var(--color-primary, #F17A20);\n  font-weight: 700;\n  position: relative;\n  border-radius: 8px;\n}\n.ant-select.single-select-filter {\n  width: 100% !important;\n  min-width: unset !important;\n}\n\n/* Submenu active item styles */\n/* ul.ml-8 li.active-menu-item,\nul.ml-8 li.active-menu-item a {\n  background-color: transparent;\n  color: var(--color-primary, #F17A20);\n  font-weight: 700;\n} */\n\n/* Remove the left accent bar for all active items */\n/* ul.ml-8 li.active-menu-item::before,\nli.active-menu-item::before,\ndiv.active-menu-item::before {\n  display: none;\n} */\n\n/* Hover styles */\nli.active-menu-item:hover, \nli.active-menu-item a:hover,\na.active-menu-item:hover,\ndiv.active-menu-item:hover {\n  border-radius: 8px;\n}\n\n/* Hover eases in. The selected row changes immediately, with no fade fighting the click. */\na.student-menu-link {\n  color: #828282;\n}\na.student-menu-link:hover {\n  background-color: #F17A201A;\n  color: #F17A20;\n  transition: background-color 120ms ease-out, color 120ms ease-out;\n}\na.student-menu-link.active-menu-item,\na.student-menu-link.active-menu-item:hover {\n  background-color: #F17A201A;\n  color: #F17A20;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
